module.exports = "/images/Icon industry-movie.svg?f013d5f648cf08e9c46ddbc891df56a5";